export const PROPS_PRODUCTS = [
  'id',
  'name',
  'productionStatus',
  'defaultImage',
  'types',
  'draft',
  'appeared',
  'category',
  'launchRegion',
  'brands',
  'manufacturers',
  'numberOfReports',
  'marketCountries',
  'uspTypes',
  'aiReady',
];

export const PROPS_TRADEMARKS = [
  'id',
  'name',
  'holders',
  'originOffice',
  'registrationOffice',
  'defaultImage',
  'niceClasses',
  'status',
  'expirationDate',
  'registrationDate',
  'registrationNumber',
  'applicationNumber',
  'applicationDate',
  'externalId',
  'types',
];

export const PROPS_CMS_TRADEMARKS = [
  'id',
  'name',
  'holders',
  'originOffice',
  'registrationOffice',
  'niceClasses',
  'status',
];

export const PROPS_COMPANIES = [
  'id',
  'defaultImage',
  'name',
  'location',
  'region',
  'numberOfBrands',
  'numberOfProducts',
  'categories',
  'draft',
  'types',
];

export const PROPS_BRANDS = [
  'id',
  'defaultImage',
  'name',
  'ownerCompanies',
  'numberOfCompanies',
  'numberOfProducts',
  'categories',
];

export const PROPS_PATENTS = [
  'inventionTitles',
  'country',
  'docNumber',
  'kind',
  'publication',
  'application',
  'id',
  'relevant',
];

export const PROPS_EVENTS = [
  'logo',
  'important',
  'name',
  'startedOn',
  'finishedOn',
  'visitation',
  'id',
  'hasReports',
  'categories',
];

export const PROPS_RESEARCHES = [
  'name',
  'summary',
  'url',
  'authors',
  'category',
  'file',
  'publishedOn',
  'id',
  'status',
  'content',
  'shortSummary',
];

export const PROPS_CMS_RESEARCHES = [
  'name',
  'summary',
  'url',
  'authors',
  'category',
  'file',
  'publishedOn',
  'id',
  'status',
  'researchCategories',
  'domain',
  'content',
  'info',
];
